import { request } from '@/utils/http';
import MultiVectorLayer from '@/utils/layers/vector/MultiVectorLayer';
import BaseEvent from '@/utils/base/BaseEvent';
import { mixClass } from '@/utils/misc';

export default class VectorMapLayer extends mixClass(
    BaseEvent,
    MultiVectorLayer
) {
    constructor(group, options) {
        super(group);
        this._options = options;
    }
    get id() {
        return ['.point', '.symbol', '.line', '.polygon', '.outline'].map(
            name => {
                return this._id + name;
            }
        );
    }

    eachLayer(callback) {
        if (this._map) {
            ['.point', '.symbol', '.line', '.polygon', '.outline'].forEach(
                (name, index) => {
                    const layer = this._map.getLayer(this._id + '.' + name);
                    if (layer) {
                        callback(layer, index);
                    }
                }
            );
        }
    }

    /**
     * 鼠标点击
     */
    clickHandler(e) {
        //mg 过滤查询图层
        let queryLayerId = []
        this._map.getStyle().layers.forEach(layer => {
            this.id.forEach(id => {
                if (layer.id === id) {
                    queryLayerId.push(layer.id);
                }
            });
        });
        const features = this._map.queryRenderedFeatures(e.point, {
            layers: queryLayerId,
        });
        const displayFields = this._options.displayFields.map(field => {
            return field.name;
        });
        const filterFeatures = features.map(feature => {
            const properties = {};
            displayFields.forEach(field => {
                properties[field] = feature.properties[field];
            });
            feature.properties = properties;
            return feature;
        });
        this.fire('click', filterFeatures);
    }

    /**
     * 添加地图对象，创建地图方案
     * @param {*} map
     */
    setMap(map) {
        const _this = this;
        if (map) {
            const options = this._options;
            if (options.isClick) {
                const _clickHandler = this.clickHandler.bind(this);
                map.on('click', _clickHandler);
            }
            this._map = map;
            //创建source
            const sourceId = _this._id + '.source';
            const source = {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: [],
                },
            };
            // 添加source
            map.addSource(sourceId, source);
            if (options.isIcon) {
                //getBFileBase64Detail
                request('admin/bFile/getBFileBase64Detail?fileId=' + options.imgId).then(res => {
                    const icon = new Image(20, 20);
                    icon.src = res.imageData;
                    icon.onload = function () {
                        if(!map.hasImage(_this._id + '.icon')){
                            map.addImage(_this._id + '.icon',icon);
                        }
                        const symbolLayer = {
                            id: _this._id + '.symbol',
                            type: 'symbol',
                            source: sourceId,
                            minzoom: options.zoomRange[0],
                            maxzoom: options.zoomRange[1],
                            filter: ['==', '$type', 'Point'],
                            layout: {
                                'icon-image': _this._id + '.icon',
                                'icon-size': 1,
                                'visibility': 'visible',
                                'icon-anchor': 'bottom',
                            },
                        };
                        map.addLayer(symbolLayer, _this._group);
                    };

                });
            } else {
                const pointLayer = {
                    id: this._id + '.point',
                    type: 'circle',
                    source: sourceId,
                    minzoom: options.zoomRange[0],
                    maxzoom: options.zoomRange[1],
                    filter: ['==', '$type', 'Point'],
                    paint: {
                        'circle-radius': options.size,
                        'circle-color': options.color,
                        'circle-opacity': 1,
                    },
                };
                const lineLayer = {
                    id: this._id + '.line',
                    type: 'line',
                    source: sourceId,
                    minzoom: options.zoomRange[0],
                    maxzoom: options.zoomRange[1],
                    filter: ['==', '$type', 'LineString'],
                    paint: {
                        'line-width': options.lineWidth,
                        'line-color': options.color,
                    },
                };
                const polygonLayer = {
                    id: this._id + '.polygon',
                    type: 'fill',
                    source: sourceId,
                    minzoom: options.zoomRange[0],
                    maxzoom: options.zoomRange[1],
                    filter: ['==', '$type', 'Polygon'],
                    paint: {
                        'fill-opacity': 0.5,
                        'fill-color': options.color,
                    },
                };
                const outlineLayer = {
                    id: this._id + '.outline',
                    type: 'line',
                    source: sourceId,
                    minzoom: options.zoomRange[0],
                    maxzoom: options.zoomRange[1],
                    filter: ['!=', '$type', 'LineString'],
                    paint: {
                        'line-color': options.outlineColor,
                        'line-width': options.outlineWidth,
                    },
                };
                map.addLayer(polygonLayer, this._group);
                map.addLayer(pointLayer, this._group);
                map.addLayer(outlineLayer, this._group);
                map.addLayer(lineLayer, this._group);
                // map.setLayoutProperty(
                //     this._id + '.polygon',
                //     'visibility',
                //     options.isFill > 0 ? 'visible' : 'none'
                // );
                map.setLayoutProperty(
                    this._id + '.outline',
                    'visibility',
                    options.outlineWidth > 0 ? 'visible' : 'none'
                );

            }
            // 保存源source
            this._source = map.getSource(sourceId);
        } else {
            if (this._map) {
                map = this._map;
                delete this._source;
                map.off('click', this.clickHandler);
                map.removeLayer(this._id + '.point');
                // map.removeLayer(this._id + '.symbol');
                map.removeLayer(this._id + '.line');
                map.removeLayer(this._id + '.polygon');
                map.removeLayer(this._id + '.outline');
                map.removeSource(this._id + '.source');

                if(map.hasImage(_this._id + '.icon')){
                    map.removeImage(_this._id + '.icon');
                }
                delete this._map;
            }
        }
    }
}
